export default {
    title: 'اعلاء العضوية',
    headerText: 'اختيار طريقة الدفع المناسبة لك حتى تتمكن من اعلاء عضويتك',
    success: 'تم الدفع بنجاح.'
}
